import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import { Nav, NavItem, NavLink, TabPane, TabContent } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import LotCreate from '~/containers/lotCreate/lotCreate';
import LotList from '~/containers/lotList/lotList';
import ConsolidatedLotList from '~/containers/consolidatedLotList/consolidatedLotList';
import styles from './styles.css';

const tabs = {
  currentLots: 'Current Lots',
  pendingLots: 'Scheduled Lots',
  completedLots: 'Completed Lots',
  consolidatedLots: 'Batches'
};

export class LotsPage extends Component {
  constructor(props) {
    const hash = props.location.hash.replace('#', '');
    super(props);
    this.state = {
      activeTab: !!tabs[hash] ? hash : 'currentLots'
    };
  }

  toggleActiveTab = activeTab => {
    this.setState({ activeTab });
  };
  render() {
    const { activeTab } = this.state;

    const createButton = <LotCreate />;
    return (
      <Page>
        <TitleBar icon="users" title="Lots" button={createButton} />
        <Nav tabs className="content">
          {Object.keys(tabs).map(k => (
            <NavItem key={k}>
              <NavLink
                className={`pointer ${cn({ [`active ${styles.active}`]: activeTab === k })}`}
                onClick={() => {
                  const { history } = this.props;
                  history.replace(`${history.location.pathname}#${k}`);
                  this.toggleActiveTab(k);
                }}
              >
                {tabs[k]}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="pendingLots">{activeTab === 'pendingLots' && <LotList status="PENDING" />}</TabPane>
          <TabPane tabId="currentLots">{activeTab === 'currentLots' && <LotList status="IN_PROGRESS" />}</TabPane>
          <TabPane tabId="completedLots">{activeTab === 'completedLots' && <LotList status="COMPLETED" />}</TabPane>
          <TabPane tabId="consolidatedLots">{activeTab === 'consolidatedLots' && <ConsolidatedLotList />}</TabPane>{' '}
        </TabContent>
      </Page>
    );
  }
}

export default connect(state => state)(withRouter(LotsPage));



// WEBPACK FOOTER //
// ./src/pages/lots/lots.jsx